import { usePermissions } from "@/providers/permissions-provider";
import { PermissionKey } from "@/types/permissions";

/**
 * Hook to check if user has specific permission(s)
 * @param permission - Single permission or array of permissions
 * @param requireAll - If true, requires all permissions. If false, requires any permission (default: false)
 * @returns true if user has the required permission(s)
 */
export function usePermission(
  permission: PermissionKey | PermissionKey[],
  requireAll: boolean = false
): boolean {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();

  if (Array.isArray(permission)) {
    return requireAll ? hasAllPermissions(permission) : hasAnyPermission(permission);
  }

  return hasPermission(permission);
}
